import API_URL from '../apiUrl';
import { apiFetch } from './api';

function getAuthHeaders() {
  const token = localStorage.getItem('access_token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
}

export async function fetchSubscriptions() {
  const response = await apiFetch(`${API_URL}/api/subscriptions/`, {
    headers: {
      ...getAuthHeaders(),
    },
  });
  if (!response.ok) throw new Error("Failed to fetch subscriptions");
  return response.json();
}

export async function addSubscription(subscription) {
  // const response = await apiFetch(`${API_URL}/api/subscriptions/`, {
  const response = await apiFetch(`${API_URL}/api/subscriptions/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(subscription),
  });
  if (!response.ok) throw new Error("Failed to subscribe");
  return response.json();
}
